import { pushSelectedItemToDatalayer } from 'js/services/datalayer';

const mobileMenu = document.querySelector('.main-navigation-mobile');
const searchMenu = document.querySelector('.search-navigation-mobile');
const mobileMenuWrapper = document.querySelector('.main-header-mobile');


const toggleNavigation = () => {
    mobileMenu.classList.contains('main-navigation-mobile--show') ?
        closeNavigation() :
        openNavigation();
};

const openNavigation = () => {
    mobileMenu.classList.add('main-navigation-mobile--show');
    searchMenu.classList.remove('search-navigation-mobile--show');
    toggleBodyScroll();
};

const closeNavigation = () => {
    mobileMenu.classList.remove('main-navigation-mobile--show');
    mobileMenuWrapper.setAttribute('data-active-tab', '0');
    toggleBodyScroll();

    setTimeout(() => {
        mobileMenu.setAttribute('data-active-sub', '0');
    }, 275);
};

const toggleSearch = () => {
    searchMenu.classList.contains('search-navigation-mobile--show') ?
        closeSearch() :
        openSearch();
};

const openSearch = () => {
    searchMenu.classList.add('search-navigation-mobile--show');
    mobileMenu.classList.remove('main-navigation-mobile--show');
    toggleBodyScroll();
};

const closeSearch = () => {
    searchMenu.classList.remove('search-navigation-mobile--show');
    mobileMenuWrapper.setAttribute('data-active-tab', '0');
    toggleBodyScroll();

    setTimeout(() => {
        searchMenu.setAttribute('data-active-sub', '0');
    }, 275);
};

const toggleBodyScroll = () => {
    if (document.body.style.overflow) {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
    } else {
        document.body.style.setProperty('overflow', 'hidden');
        document.body.style.setProperty('padding-right', '0px');
    }
};

// Toggle
if (mobileMenuWrapper && mobileMenu && searchMenu) {
    mobileMenuWrapper.addEventListener('click', (event) => {
        const actionElement = event.target.closest('[data-header-tab]');
        if (!actionElement) return;

        const tab = actionElement.dataset.headerTab;

        if (tab) {
            mobileMenuWrapper.setAttribute('data-active-tab', tab);

            switch (tab) {
            case 'menu':
                toggleNavigation();
                break;
            case 'search':
                toggleSearch();
                break;
            }

            pushSelectedItemToDatalayer(actionElement.dataset.pushAction, actionElement.dataset.pushValue, true);
        }
    });

    searchMenu.addEventListener('click', (event) => {
        const actionElement = event.target.closest('[data-nav-action]');
        if (!actionElement) return;

        const action = actionElement.dataset.navAction;

        if (action) {
            switch (action) {
            case 'close-nav':
                closeSearch();
                break;
            }
        }
    });

    mobileMenu.addEventListener('click', (event) => {
        const actionElement = event.target.closest('[data-nav-action]');
        if (!actionElement) return;

        const action = actionElement.dataset.navAction;
        const subIndex = actionElement.dataset.subIndex;

        if (action) {
            switch (action) {
            case 'open-sub-nav':
                if (subIndex) {
                    mobileMenu.setAttribute('data-active-sub', subIndex);
                }
                pushSelectedItemToDatalayer(actionElement.dataset.pushAction, actionElement.dataset.pushValue, true);
                break;
            case 'close-sub-nav':
                mobileMenu.setAttribute('data-active-sub', '0');
                break;
            case 'follow-link':
                pushSelectedItemToDatalayer(actionElement.dataset.pushAction, actionElement.dataset.pushValue, true);
                break;
            case 'close-nav':
                closeNavigation();
                break;
            }
        }
    });
}

const elements = [
    mobileMenu,
    searchMenu,
    mobileMenuWrapper,
];

function updateVisibility() {
    const isNarrow = window.innerWidth < 1200;

    elements.forEach((el) => {
        if (!el) return;

        if (isNarrow) {
            el.removeAttribute('hidden');
        } else {
            el.setAttribute('hidden', '');
        }
    });
}

window.addEventListener('DOMContentLoaded', updateVisibility);

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateVisibility, 150);
});
